import React, { useEffect, useState, useRef, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Echo from 'laravel-echo';
import Pusher from 'pusher-js'; // eslint-disable-line no-unused-vars
import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import { DebounceInput } from 'react-debounce-input'
import Select from 'react-select'

import Map from 'pages/delivery/Map'
import MapOrder from 'pages/delivery/MapOrder'
import NewAddress from 'pages/delivery/NewAddress'
import OperatorProfileBlock from 'pages/delivery/OperatorProfileBlock'
import Rightbar from 'pages/main/cheques/Rightbar'
import DeleteModalCheque from 'pages/parts/DeleteModal'
import DeleteModalCourier from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import useDidMountEffect from 'pages/parts/useDidMountEffect'

import { clearTemporaryStorage, externalCourierStatus, formatDate, formatMoney, regexPhoneNumber, returnSign } from 'helpers/helpers'
import { httpOk, DELETE, GET, PUT, POST } from 'helpers/api'

const orderStatusTabs = [
	{ id: 'all', name: 'all_orders' },
	{ id: '-12', name: 'unconfirmed', dot: 'danger' },
	{ id: '-11', name: 'not_paid', dot: 'danger' },
	{ id: '-10', name: 'new', dot: 'danger' },
	{ id: '0', name: 'received', dot: 'danger' },
	{ id: '1', name: 'cooking', dot: 'warning' },
	{ id: '7', name: 'collected', dot: 'info' },
	{ id: '8', name: 'on_the_way', dot: 'primary' },
	{ id: '9', name: 'delivered', dot: 'success' },
]

// Активный заказ дольше часа с момента открытия подсвечиваем как просроченный.
// Своего норматива времени у колл-центра нет — порог общий
const ORDER_OVERDUE_MINUTES = 60

function isOrderOverdue(item, currentTime) {
	if (!item?.cheque_opened_at || Number(item.status) >= 9) return false
	const openedAt = new Date(String(item.cheque_opened_at).replace(' ', 'T')).getTime()
	if (Number.isNaN(openedAt)) return false
	return currentTime - openedAt > ORDER_OVERDUE_MINUTES * 60 * 1000
}

// Без имени бэкенд отдаёт в client_name тот же номер — второй раз его не показываем
function hasRealClientName(item) {
	const name = String(item?.client_name ?? '').trim()
	if (!name) return false
	const digits = name.replace(/\D/g, '')
	return !(digits.length >= 9 && digits === name.replace(/[\s+()-]/g, ''))
}

function hasText(value) {
	const text = String(value ?? '').trim()
	return text !== '' && text !== '-'
}

function formatElapsedOrderTime(openedAt, currentTime) {
	if (!openedAt) return '--:--:--'

	const normalizedOpenedAt = typeof openedAt === 'string'
		? openedAt.replace(' ', 'T')
		: openedAt
	const openedAtTime = new Date(normalizedOpenedAt).getTime()
	if (Number.isNaN(openedAtTime)) return '--:--:--'

	const totalSeconds = Math.max(0, Math.floor((currentTime - openedAtTime) / 1000))
	const days = Math.floor(totalSeconds / 86400)
	const hours = Math.floor((totalSeconds % 86400) / 3600)
	const minutes = Math.floor((totalSeconds % 3600) / 60)
	const seconds = totalSeconds % 60
	const time = [hours, minutes, seconds]
		.map(value => String(value).padStart(2, '0'))
		.join(':')

	return days > 0 ? `${days}д ${time}` : time
}

// status -20 новый в cloud остался telegram bot
// status -15 новый в cloud остался call center
// status 0 не получен торговой точкой
// status 1 Готовиться
// status 2 Пора готовить
// status 3 Готовиться
// status 4 Приготовлено
// status 5 Подано
// status 8 Курьер выехал
// status 9 Курьер доставил и принял оплату
// status 10 успешно оплачен закрытый чек

function Orders() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const echoRef = useRef(null)
	const posesRef = useRef([]);

	const reduxAccount = useSelector(state => state.account)
	const reduxDelivery = useSelector(state => state.delivery)

	const [data, setData] = useState([])
	// Время для таймеров в колонке «Время» — тикает раз в секунду
	const [currentTime, setCurrentTime] = useState(Date.now())
	const [allData, setAllData] = useState([])
	const [poses, setPoses] = useState(reduxDelivery.poses)
	const [paymentTypes, setPaymentTypes] = useState([])
	const [searchValue, setSearchValue] = useState('')
	const [selectedItem, setSelectedItem] = useState({})
	const [showRightBar, setShowRightBar] = useState(false)
	const [newAddress, setNewAddress] = useState({
		'latitude': '',
		'longitude': '',
		'new_address': '',
		'address': '',
		'pos_name': '',
		'distance': '',
	});
	// CLIENT UPDATE LOGIC
	const [client, setClient] = useState({})
	const [modalClient, setModalClient] = useState(false)
	// CLIENT UPDATE LOGIC
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [cheques, setCheques] = useState([]);
	const [modal, setModal] = useState({
		'branches': false,
		'map': false,
	})
	const [modalMap, setModalMap] = useState(false)
	const [modalAddress, setModalAddress] = useState(false)
	const [modalInvoice, setModalInvoice] = useState(false)
	const [modalCheques, setModalCheques] = useState(false)
	const [modalPaymentTypes, setModalPaymentTypes] = useState(false)
	const [modalClosedCheques, setModalClosedCheques] = useState(false)
	const [modalPreorderCheques, setModalPreorderCheques] = useState(false)
	const [filterData, setFilterData] = useState({
		start_date: formatDate(new Date(), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		activeTab: 'all',
	})
	const [pagination, setPagination] = useState({
		url: '/cheques',
		response: null
	})
	const [modalDelete, setModalDelete] = useState({
		'cheque': false,
		'courier': false,
	})
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })

	async function deleteCourier() {
		await PUT(`/delivery/delete-courier`, {
			'id': deleteModalParams.id
		}, { loader: true })
		setModalDelete({
			'cheque': false,
			'courier': false,
		})
	}

	async function deleteCheque() {
		await DELETE(`/delivery/cheque/${deleteModalParams.id}`, {}, { loader: true })
		setModalDelete({
			'cheque': false,
			'courier': false,
		})
	}

	async function sendInvoice(e) {
		e.preventDefault()

		const response = await POST(`/delivery/cheques/send-invoice`, selectedItem, { loader: true })
		if (httpOk(response)) toggleModalInvoice()
	}

	async function changePaymentType(item) {
		const response = await POST(`/delivery/change-payment`, {
			'cheque_id': selectedItem.cheque_id,
			'payment_type_id': item.payment_type_id,
		}, { loader: true })
		if (httpOk(response)) {
			getCheques()
			toggleModalPayments()
		}
	}

	async function changeStatus(item, status = null) {
		if (!status) return

		const response = await PUT(`/delivery/change-status`, {
			'id': item.id,
			'status': status,
		}, { loader: true })
		if (httpOk(response)) toggleModalInvoice()
	}

	async function changeAddress(e) {
		e.preventDefault();

		const response = await PUT(`/delivery/cheques/change-address`, {
			'cheque_id': selectedItem.cheque_id,
			'navigate': selectedItem.navigate,
			'address_id': selectedItem.address_id,
		}, { loader: true })

		if (httpOk(response)) {
			getCheques()
			toggleModalAddress()
		}
	}

	function handleClientChange(e) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy[e.target.name] = e.target.value
		setSelectedItem(selectedItemCopy)
	}

	async function parseCoordinates(value) {
		setSelectedItem({ ...selectedItem, 'coordinates': value })
		var numbers = value.replace(/\s/g, '').split(",")
		var lattitude = numbers[0];
		var longitude = numbers[1];

		if (longitude && lattitude) {
			var response = await POST('/clients-create-address', {
				'client_id': selectedItem.client_id,
				'latitude': lattitude,
				'longitude': longitude,
			}, { loader: true })

			if (httpOk(response)) {
				response = response.data

				var clientCopy = { ...client }
				if (clientCopy.addresses.length) {
					clientCopy.addresses.unshift(response)
				} else {
					clientCopy.addresses = []
					clientCopy.addresses.push(response)
				}

				setClient(clientCopy)
				handleSelectAddress(clientCopy, response, 0)
			}
		}
	}

	async function syncCheque(id) {
		await GET(`/delivery/sync/${id}`, {}, { loader: true })
	}

	async function confirmCheque(cheque_id) {
		await POST(`/delivery/cheques/confirm`, {
			'cheque_id': cheque_id
		}, { loader: true })
	}

	function returnClassStatus(status) {
		if (status === 1) {
			return "bg-primary text-white"
		}
		if (status === 2) {
			return "bg-warning text-white"
		}
		if (status === 3) {
			return "bg-success text-white"
		}
	}

	function returnOnlineStatus(item) {
		if (item.online) {
			return { 'backgroundColor': '#34c38f' };
		} else {
			return { 'backgroundColor': '#f46a6a' };
		}
	}

	function search(value, response) {
		if (!value) {
			setData(allData)
			return;
		}

		var dataCopy = [...allData];
		if (response) dataCopy = [...response];

		const searchValue = value.toLowerCase();
		const filteredData = dataCopy.filter((item) => {

			return (
				item?.id?.toString().includes(searchValue) ||
				item?.cheque_number?.toString().includes(searchValue) ||
				item?.client_name?.toLowerCase().includes(searchValue) ||
				item?.client_phone1?.toLowerCase().includes(searchValue) ||
				item?.client_address?.toLowerCase().includes(searchValue) ||
				item?.total_amount_service?.toString().includes(searchValue)
			);
		});

		setData(filteredData)
		setSearchValue(searchValue)
	}

	async function toggleRightbar(boolean = false, item, index) {
		var dataCopy = [...data]

		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[i]['showSidebar'] = false
		}
		if (boolean) {
			const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				dataCopy[index] = response.data.data
				dataCopy[index]['showSidebar'] = boolean

				setSelectedItem(dataCopy[index])
				setShowRightBar(boolean)
			}
		} else {
			setShowRightBar(boolean)
			setSelectedItem({})
		}
	}

	function goTo(page = 'create', item = {}) {
		if (page === -1) {
			dispatch({ type: 'USER_LOGGED_OUT', payload: null })
			clearTemporaryStorage()
			navigate('/auth/login')
			return
		}
		if (page === 'create') {
			navigate('/delivery/create')
			return
		}
		if (page === 'update') {
			navigate(`/delivery/update/${item.cheque_id}`)
			return
		}
	}

	async function createClientAddress() {
		const response = await POST('/clients-create-address', {
			'client_id': selectedItem.client_id,
			'longitude': newAddress?.longitude,
			'latitude': newAddress?.latitude,
			'full_address': newAddress?.full_address,
			'short_address': newAddress?.short_address,
		}, { loader: true })

		if (httpOk(response)) {
			var selectedItemCopy = JSON.parse(JSON.stringify(selectedItem))

			selectedItemCopy.addresses.unshift(response.data)
			setSelectedItem(selectedItemCopy)
			console.log(selectedItemCopy)
			toggleModalMap()
		}
	}

	// CLIENT UPDATE LOGIN
	async function toggleModalClient(bool = false, item = {}) {
		if (bool && item?.client_phone) {
			var response = await GET(`/search-client/${item.client_phone}`, {}, { loader: true })
			if (httpOk(response)) setSelectedItem(response.data)
		}

		setModalClient(bool)
	}

	async function updateClient(e) {
		e.preventDefault()

		var response = await PUT(`/delivery/clients/${selectedItem.id}`, selectedItem, { loader: true });
		if (httpOk(response)) {
			getCheques()
			toggleModalClient()
		}
	}
	// CLIENT UPDATE LOGIN

	async function toggleModalCheques(bool = false) {
		if (bool) {
			var filterDataCopy = { ...filterData }
			var filterUrl = "/report-operators"
			var urlParams = ""

			if (filterDataCopy.start_date)
				urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
			if (filterDataCopy.end_date)
				urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
			filterUrl = filterUrl + urlParams

			const response = await GET(filterUrl, {}, { loader: true })
			if (httpOk(response)) {
				console.log(response.data)
				setCheques(response.data)
				setDropdownIsOpen(false)
			}
		} else {
			setCheques([])
		}

		setModalCheques(bool)
	}

	async function toggleModalInvoice(bool = false, item = {}) {
		if (bool) {
			const filteredPayments = reduxDelivery.paymentTypes.filter(paymentType => (paymentType.payment_type_category_id === 5));
			setPaymentTypes(filteredPayments)
		}

		setSelectedItem({
			'cheque_id': item.id,
			'client_phone': item.client_phone,
			'payment_type_id': null,
			'amount': item.total_amount_service,
		})
		setModalInvoice(bool)
	}

	async function toggleModalAddress(bool = false, item = {}) {
		if (bool) {
			var response = await GET(`/search-client/${item.client_phone}`)
			if (httpOk) {
				var selectedItemCopy = JSON.parse(JSON.stringify(item))

				selectedItemCopy.addresses = response.data.addresses
				setSelectedItem(selectedItemCopy)
			}
			if (!httpOk) return
		}

		if (!bool) setSelectedItem({})

		setModalAddress(bool)
	}

	function toggleModalMap(bool = false) {
		setModalMap(bool)
		setNewAddress({
			'latitude': '',
			'longitude': '',
			'new_address': '',
			'address': '',
			'pos_name': '',
			'distance': '',
		})
	}

	async function toggleModalClosedCheques(bool = false) {
		if (bool) {
			var filterDataCopy = { ...filterData }
			var filterUrl = "/cheques"
			var urlParams = ""

			if (filterDataCopy.start_date)
				urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
			if (filterDataCopy.end_date)
				urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
			if (filterDataCopy.search)
				urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
			if (filterDataCopy.page)
				urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

			filterUrl = filterUrl + urlParams

			const response = await GET(filterUrl, {}, { loader: true })
			if (httpOk(response)) {
				setCheques(response.data)
				setPagination({ ...pagination, 'url': filterData.url, 'response': response.data })
				setDropdownIsOpen(false)
			}
		}

		if (!bool) setCheques([])

		setModalClosedCheques(bool)
	}

	async function toggleModalPreorderCheques(bool = false) {
		if (bool) {
			var filterDataCopy = { ...filterData }
			var filterUrl = "/cheques-preorders"
			var urlParams = ""

			if (filterDataCopy.start_date)
				urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
			if (filterDataCopy.end_date)
				urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date

			// urlParams += returnSign(urlParams) + 'start_date=' + formatDate(new Date(), 'yyyy-MM-dd')
			// urlParams += returnSign(urlParams) + 'end_date=' + formatDate(new Date(new Date().setDate(new Date().getDate() + 7)), 'yyyy-MM-dd')
			filterUrl = filterUrl + urlParams

			const response = await GET(filterUrl, {}, { loader: true })
			if (httpOk(response)) {
				setCheques(response.data)
				setDropdownIsOpen(false)
			}
		}

		if (!bool) setCheques([])

		setModalPreorderCheques(bool)
	}

	function toggleModalPayments(bool = false, item = {}) {
		setSelectedItem(item)
		setModalPaymentTypes(bool)
	}

	async function toggleModal(bool = false, type = '', item = {}) {
		if (type === 'dashboard') {
			setModal({ ...modal, 'dashboard': bool })
		}
		if (type === 'branches') {
			setModal({ ...modal, 'branches': bool })
		}
		if (type === 'map') {
			setModal({ ...modal, 'map': bool })
		}
		if (type === 'mapOrder') {
			setModal({ ...modal, 'mapOrder': bool, 'item': item })
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function clearSelectedAddress() {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy.address_id = null
		selectedItemCopy.address = null

		selectedItemCopy.apartment = null
		selectedItemCopy.floor = null
		selectedItemCopy.entrance = null
		selectedItemCopy.intercom = null
		selectedItemCopy.navigate = null

		setSelectedItem(selectedItemCopy)
	}

	async function handleSelectAddress(item) {
		var selectedItemCopy = { ...selectedItem }

		selectedItemCopy.address = item.name
		selectedItemCopy.address_id = item.id

		selectedItemCopy.apartment = item.apartment ?? null
		selectedItemCopy.floor = item.floor ?? null
		selectedItemCopy.entrance = item.entrance ?? null
		selectedItemCopy.intercom = item.intercom ?? null
		selectedItemCopy.navigate = item.navigate ?? null

		setSelectedItem(selectedItemCopy)
	}

	function returnStatusClass(status) {
		if (status === -12) {
			return "bg-danger text-white"
		}
		if (status === -11) {
			return "bg-danger text-white"
		}
		if (status === -10) {
			return "bg-danger text-white"
		}
		if (status === 0) {
			return "bg-danger text-white"
		}
		if (status === 1) {
			return "bg-primary text-white"
		}
		if (status === 7) {
			return "bg-primary text-white"
		}
		if (status === 8) {
			return "bg-primary text-white"
		}
		if (status === 9) {
			return "bg-success text-white"
		}
		if (status === 10) {
			return "bg-dark text-white"
		}
	}

	function returnStatus(status) {
		if (status === -12) {
			return t('unconfirmed')
		}
		if (status === -11) {
			return t('not_paid')
		}
		if (status === -10) {
			return t('new')
		}
		if (status === 0) {
			return t('received')
		}
		if (status === 1) {
			return t('cooking')
		}
		if (status === 7) {
			return t('collected')
		}
		if (status === 8) {
			return t('on_the_way')
		}
		if (status === 9) {
			return t('delivered')
		}
		if (status === 10) {
			return t('closed')
		}
	}

	async function connectSocket() {
		var wsHost;
		var wsPort;
		var authEndpoint;
		var isProd;

		if (process.env.NODE_ENV === 'production') {
			wsHost = reduxAccount.configs.ws.host
			authEndpoint = reduxAccount.configs.ws.authEndpoint
			wsPort = 443
			isProd = true
		} else {
			wsHost = process.env.REACT_APP_DEV_WSHOST
			authEndpoint = process.env.REACT_APP_DEV_BROADCAST_AUTH
			wsPort = 6001
			isProd = false
		}

		if (echoRef.current) return

		try {
			echoRef.current = new Echo({
			broadcaster: reduxAccount.configs.ws.broadcaster,
				key: "mison_key",
				wsHost: wsHost,
				wsPort: wsPort,
				wssPort: wsPort,
				enabledTransports: ['ws', 'wss'],
				disableStats: true,
				encrypted: isProd ? true : false,
				useTLS: isProd ? true : false,
				forceTLS: isProd ? true : false,
				authEndpoint: authEndpoint,
				auth: {
					headers: {
						'Authorization': `Bearer ${reduxAccount.token}`
					}
				},
			});
		} catch (error) {
			console.log(error)
		}

		echoRef.current.connector.pusher.connection.bind('connected', () => {
			console.log('connected private channel');
		});

		echoRef.current.connector.pusher.connection.bind('disconnected', () => {
			console.log('disconnected private channel');
		});

		echoRef.current.private(`call-center.${reduxAccount.parent}`)
			.listen('Cheques', (payload) => {
				console.log('payload: ', payload.data)

				var response = payload.data

				if (data.length !== response.length) {
					var posesCopy = posesRef.current
					for (let i = 0; i < posesCopy.length; i++) {
						posesCopy[i]['count'] = 0
						for (let j = 0; j < response.length; j++) {
							if (posesCopy[i]['id'] === response[j]['pos_id']) {
								posesCopy[i]['count'] += 1
							}
						}
					}

					setPoses(posesCopy)
					posesRef.current = posesCopy;
				}

				if (searchValue) {
					search(searchValue, payload.data)
				} else {
					setData(payload.data)
				}
				setAllData(payload.data)
			});

		echoRef.current.join(`presence-call-center-${reduxAccount.parent}`)
			.here((users) => { // (users)
				console.log('connected presence-call-center', users)
				users = users.filter(item => item.role !== "ROLE_CALL_CENTER")
				console.log('here', users)

				const posesCopy = posesRef.current.map(pos => {
					const updatedPos = { ...pos }; // Создаём новый объект
					updatedPos.online = users.some(user => user.pos_id === pos.id);
					return updatedPos;
				});

				setPoses(posesCopy); // Создаём новый массив
				posesRef.current = posesCopy;
			})
			.joining((user) => {
				console.log('joining', user)
				if (user.role === "ROLE_CALL_CENTER") { return }

				var posesCopy = [...reduxDelivery?.poses]
				for (let i = 0; i < posesCopy.length; i++) {
					if (posesCopy[i]['id'] === user.pos_id) {
						posesCopy[i]['online'] = true
						break;
					}
				}

				setPoses(posesCopy)
			})
			.leaving((user) => {
				console.log('leaving', user)
				if (user.role === "ROLE_CALL_CENTER") { return }

				var posesCopy = [...reduxDelivery?.poses]
				for (let i = 0; i < posesCopy.length; i++) {
					if (posesCopy[i]['id'] === user.pos_id) {
						posesCopy[i]['online'] = false
						break;
					}
				}

				setPoses(posesCopy)
			})
	}

	async function getCheques() {
		var response = await GET('/delivery/cheques', {}, { loader: true })

		if (httpOk(response)) {
			response = response.data
			if (!posesRef.current) posesRef.current = reduxDelivery?.poses
			let posesCopy = [...posesRef.current]; // Берём актуальные данные poses
			for (let i = 0; i < posesCopy.length; i++) {
				posesCopy[i]['count'] = 0;
				for (let j = 0; j < response.length; j++) {
					if (posesCopy[i]['id'] === response[j]['pos_id']) {
						posesCopy[i]['count'] += 1;
					}
				}
			}

			setPoses(posesCopy); // Обновляем poses количеством заказов
			posesRef.current = posesCopy;

			setData(response)
			setAllData(response)
		}
	}

	function filterAndSortCheques() {
		let dataCopy = [...data]

		if (filterData.activeTab !== "all") {
			dataCopy = dataCopy.filter(item => String(item.status) === String(filterData.activeTab));
		}

		// сортировка (пример: новые сверху по дате)
		dataCopy.sort((a, b) => new Date(b.cheque_opened_at) - new Date(a.cheque_opened_at));

		return dataCopy;
	}

	function getChequeCountByStatus(status) {
		let dataCopy = [...data]; // копия массива чеков

		if (status === "all") {
			return dataCopy.length || "";
		}

		const count = dataCopy.filter(item => String(item.status) === String(status)).length;

		return count === 0 ? "" : count;
	}

	async function initializeData() {
		posesRef.current = reduxDelivery.poses

		connectSocket();
		await getCheques();
	}

	async function paginate(page) {
		setFilterData({ ...filterData, 'page': page })
	}

	useEffect(() => {
		initializeData()

		return () => {
			// echoRef?.current?.leave(`call-center.${reduxAccount.parent}`)
			// echoRef?.current?.leave(`presence-call-center-${reduxAccount.parent}`)
			echoRef?.current?.disconnect()
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		toggleModalClosedCheques(true)
	}, [filterData.search, filterData.page]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const timer = setInterval(() => setCurrentTime(Date.now()), 1000)
		return () => clearInterval(timer)
	}, [])

	return (
		<>
			<div className="d-flex" style={{ 'height': 'calc(100vh - 50px)', paddingTop: '50px' }}>
				<div className="delivery-header gap-3">
					<div className="d-flex" style={{ 'flex': 1 }}>
						<div className="delivery-header-item"
							onClick={() => toggleModal(true, 'branches')}>
							<div className="position-relative">
								<span>{t('branches')}</span>
								<span className="badge bg-primary"
									style={{ 'position': 'absolute', 'right': '-10px', 'top': '-7px' }}>
									{poses?.length}
								</span>
							</div>
						</div>

						<div className="delivery-header-item"
							onClick={() => toggleModalCheques(true)}>
							<span>{t('operators')}</span>
						</div>
					</div>

					<div className="delivery-header-search" style={{ 'flex': 3 }}>
						<i className="uil-search"></i>
						<DebounceInput
							type="text"
							value={searchValue}
							placeholder={t('search') + '...'}
							minLength={3}
							debounceTimeout={500}
							onChange={(e) => search(e.target.value)}
							onKeyUp={(e) => {
								if (e.keyCode === 13) {
									search(e.target.value)
								}
							}}
						/>
					</div>

					<div className="d-flex gap-2 align-items-center justify-content-end" style={{ 'flex': 2 }}>
						<button className="btn btn-info text-nowrap"
							style={{ minWidth: '150px' }}
							onClick={() => toggleModal(true, 'map')}>
							<span><i className="uil uil-map-marker"></i> {t('map')}</span>
						</button>

						<button className="btn btn-primary text-nowrap"
							style={{ minWidth: '150px' }}
							onClick={() => goTo('create')}>
							<span><i className="uil uil-plus"></i> {t('new_order')}</span>
						</button>

						{/* Выход теперь в меню плашки оператора — как в Mison */}
						<OperatorProfileBlock
							chipClassName="operator-profile-chip--inline"
							onLogout={() => goTo(-1)}
						/>
					</div>
				</div>

				<div className="delivery-footer">
					<div className="delivery-footer-tabs">
						{orderStatusTabs.map(tab => {
							const count = getChequeCountByStatus(tab.id)
							return (
								<div key={tab.id}
									className={`delivery-footer-tab ${filterData.activeTab === tab.id ? 'active' : ''} ${!count ? 'empty' : ''}`}
									onClick={() => setFilterData({ ...filterData, 'activeTab': tab.id })}>
									{!!tab.dot && <span className={`delivery-footer-dot ${tab.dot}`}></span>}
									<span>{t(tab.name)}</span>
									{!!count && <span className="delivery-footer-count">{count}</span>}
								</div>
							)
						})}

						<div className="delivery-footer-divider"></div>
						<div className="delivery-footer-tab"
							onClick={() => toggleModalClosedCheques(true)}>
							<i className="uil uil-archive"></i>
							<span>{t('closed')}</span>
						</div>
						<div className="delivery-footer-tab"
							onClick={() => toggleModalPreorderCheques(true)}>
							<i className="uil uil-calendar-alt"></i>
							<span>{t('pre_order')}</span>
						</div>
					</div>
				</div>

				<div className="w-100" style={{ 'background': '#fff' }}>
					<div className="table-responsive h-table-orders table-fixed">
						<table className="table table-hover delivery-table cursor mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%', 'minWidth': '115px' }} className="text-center">{t('time')}</th>
									<th style={{ 'minWidth': '90px' }} className="text-center">№/ID</th>
									<th style={{ 'minWidth': '120px' }} className="text-center">{t('order_type')}</th>
									<th style={{ 'minWidth': '140px' }} className="text-center td-ellipsis">{t('branch')}</th>
									<th style={{ 'minWidth': '140px' }}>{t('client')}</th>
									<th style={{ 'width': '40%' }}>{t('address')}</th>
									<th style={{ 'minWidth': '140px' }}>{t('courier')}</th>
									<th style={{ 'minWidth': '120px' }}>{t('cashier')}</th>
									<th style={{ 'width': '15%' }} className="text-center">{t('comment')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('amount')}</th>
									<th style={{ 'width': '15%' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{filterAndSortCheques(data).map((item, index) => (
									<Fragment key={index}>
										<tr>
											<td className="text-center" style={{ 'height': '60px' }}>{index + 1}</td>
											<td className={`text-center position-relative ${returnStatusClass(item.status)}`}
												onClick={() => toggleRightbar(true, item, index)}>
												<div className="d-flex flex-column align-items-center gap-1">
													<b className="fz-20 lh-1">{formatDate(item.cheque_opened_at, 'HH:mm')}</b>
													<span className="text-nowrap">{returnStatus(item.status)}</span>
													{/* Сколько прошло с открытия заказа; дольше часа — красным */}
													<span className={`delivery-elapsed ${isOrderOverdue(item, currentTime) ? 'overdue' : ''}`}
														title={t('time')}>
														<i className="uil uil-clock"></i>
														{formatElapsedOrderTime(item.cheque_opened_at, currentTime)}
													</span>
												</div>
											</td>
											<td onClick={() => toggleRightbar(true, item, index)}>
												<div className="d-flex flex-column gap-1">
													<div className="text-center" title={`№ ` + t('cheque')}>
														{item.cheque_number ? item.cheque_number : `-`}
													</div>
													<div className="text-center" title={`ID ` + t('cheque')}>
														{item.id}
													</div>
												</div>
											</td>
											<td onClick={() => toggleRightbar(true, item, index)}
												className="td-ellipsis">
												<div className="d-flex justify-content-center">
													{item.order_type === 2 &&
														<div className="d-flex flex-column align-items-center">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="24"
																height="24"
																viewBox="0 0 24 24"
																fill="none"
																stroke="currentColor"
																strokeWidth="2"
																strokeLinecap="round"
																strokeLinejoin="round"
																className="text-warning">
																<path stroke="none" d="M0 0h24v24H0z" fill="none" />
																<path d="M13 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
																<path d="M7 21l3 -4" />
																<path d="M16 21l-2 -4l-3 -3l1 -6" />
																<path d="M6 12l2 -3l4 -1l3 3l3 1" />
															</svg>
														</div>
													}
													{item.order_type === 3 &&
														<>
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="24"
																height="24"
																viewBox="0 0 24 24"
																fill="none"
																stroke="currentColor"
																strokeWidth="2"
																strokeLinecap="round"
																strokeLinejoin="round"
																className="text-info">
																<path stroke="none" d="M0 0h24v24H0z" fill="none" />
																<path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
																<path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
																<path d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5" />
															</svg>
															<div className="vertical-center">{item.delivery_distance ? `${item.delivery_distance} km` : '-'}</div>
														</>
													}

												</div>
												<div className="text-center"><b>{item.order_type_sub_name}</b></div>
											</td>
											<td className="td-ellipsis"
												onClick={() => toggleRightbar(true, item, index)}>
												<div className="text-center">{item.pos_name ?? '-'}</div>
											</td>
											<td onClick={() => toggleRightbar(true, item, index)}>
												<div>
													<div className="d-flex flex-column gap-1">
														{/* Без имени в client_name лежит тот же номер — второй раз не показываем */}
														{hasRealClientName(item) &&
															<div className="custom-truncate">{item.client_name}</div>
														}
														<div className="text-info">+{regexPhoneNumber(item.client_phone)}</div>
													</div>
												</div>
											</td>
											<td onClick={() => toggleRightbar(true, item, index)}>
												<div className="d-flex flex-column gap-1">
													{hasText(item.client_address) && <div>{item.client_address}</div>}
													{hasText(item.navigate) && <b>{item.navigate}</b>}
													{!hasText(item.client_address) && !hasText(item.navigate) &&
														<span className="text-muted">—</span>
													}
												</div>
											</td>
											<td onClick={() => toggleRightbar(true, item, index)}>
												<div className="d-flex flex-column gap-1">
													{!!item.courier_id &&
														<>
															<div className="custom-truncate">{item.courier_name}</div>
															<div className="text-info">+{regexPhoneNumber(item.courier_phone)}</div>
														</>
													}

													{/* Внешняя служба: какая, что с заявкой и — когда курьер найден — кто он */}
													{!!item.external_courier_id &&
														<>
															<div className="custom-truncate">
																<b>{item.external_courier_name ?? t('external_courier')}</b>
															</div>
															<div className={`fw-600 ${externalCourierStatus(item.external_courier_status).color}`}>
																{t(externalCourierStatus(item.external_courier_status).key)}
															</div>
															{!!(item?.external_courier_info?.courierName || item?.external_courier_info?.driverName) &&
																<div className="custom-truncate">
																	{item.external_courier_info.courierName || item.external_courier_info.driverName}
																</div>
															}
														</>
													}
													{(!!item?.external_courier_info?.phoneNumber || !!item?.external_courier_info?.trackingUrl) &&
														<div className="d-flex align-items-center gap-2">
															{!!item?.external_courier_info?.phoneNumber &&
																<span className="text-info">
																	+{regexPhoneNumber(item.external_courier_info.phoneNumber)}
																</span>
															}
															{/* Ссылка открывается в новой вкладке, а клик не должен
																открывать ещё и карточку заказа */}
															{!!item?.external_courier_info?.trackingUrl &&
																<a href={item.external_courier_info.trackingUrl}
																	target="_blank" rel="noreferrer"
																	title={t('courier_tracking')}
																	className="text-primary fs-5 lh-1"
																	onClick={(e) => e.stopPropagation()}>
																	<i className="uil uil-map-marker-alt"></i>
																</a>
															}
														</div>
													}

													{!item.courier_id && !item.external_courier_id &&
														<span>-</span>
													}
												</div>
											</td>
											<td onClick={() => toggleRightbar(true, item, index)}>
												{hasText(item.cashier_name) ? item.cashier_name : <span className="text-muted">—</span>}
											</td>
											<td className="text-center"
												onClick={() => toggleRightbar(true, item, index)}>
												{item.note ?? '-'}
											</td>
											<td onClick={() => toggleRightbar(true, item, index)}>
												<div className="d-flex justify-content-between gap-3">
													{item.payment_category_value === 'cash' &&
														<svg
															xmlns="http://www.w3.org/2000/svg"
															fill="none"
															viewBox="0 0 24 24"
															strokeWidth={1.5}
															stroke="currentColor"
															style={{
																'width': '30px',
																'color': Number(item.paid) === Number(item.total_amount_service) ? '#34c38f' : 'inherit',
															}}>
															<path
																strokeLinecap="round"
																strokeLinejoin="round"
																d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
															/>
														</svg>
													}
													{item.payment_category_value === 'terminal' &&
														<svg
															xmlns="http://www.w3.org/2000/svg"
															fill="none"
															viewBox="0 0 24 24"
															strokeWidth={1.5}
															stroke="currentColor"
															style={{
																'width': '30px',
																'color': Number(item.paid) === Number(item.total_amount_service) ? '#34c38f' : 'inherit',
															}}>
															<path
																strokeLinecap="round"
																strokeLinejoin="round"
																d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
															/>
														</svg>
													}
													<div className="text-end">
														<b className="text-nowrap fz-20">{formatMoney(item.total_amount_service)}</b>
														<div>{item.payment_name}</div>
													</div>
												</div>
											</td>
											<td>
												<div className="table-dropdown">
													<Dropdown id={`dropdown-${index}`}>
														<Dropdown.Toggle variant="outline-primary">
															<i className="uil uil-ellipsis-v"></i>
														</Dropdown.Toggle>

														<Dropdown.Menu>
															{item.status < 7 &&
																<div className="table-dropdown-item d-non"
																	onClick={() => goTo('update', item)}>
																	<i className="uil-edit"></i>
																	{t('edit')}
																</div>
															}

															{item.status < 7 &&
																<div className="table-dropdown-item"
																	onClick={() => toggleModalAddress(true, item)}>
																	<i className="uil-map"></i>
																	{t('change_address')}
																</div>
															}

															{item.status === -12 &&
																<div className="table-dropdown-item"
																	onClick={() => confirmCheque(item.cheque_id)}>
																	<i className="uil-check-square"></i>
																	{t('confirm')}
																</div>
															}

															{item.status === -10 &&
																<div className="table-dropdown-item"
																	onClick={() => syncCheque(item.cheque_id)}>
																	<i className="uil-refresh"></i>
																	{t('synchronize')}
																</div>
															}

															{Number(item.paid) === 0 &&
																<div className="table-dropdown-item"
																	onClick={() => toggleModalPayments(true, item)}>
																	<i className="uil-sync"></i>
																	{t('change_payment')}
																</div>
															}

															{item.status_value === 'PACKED' &&
																<div className="table-dropdown-item"
																	onClick={() => changeStatus(item, 8)}>
																	<i className="uil-truck"></i>
																	{t('on_the_way')}
																</div>
															}

															{item.status_value === 'TAKEN_BY_COURIER' &&
																<div className="table-dropdown-item"
																	onClick={() => changeStatus(item, 9)}>
																	<i className="uil-truck"></i>
																	{t('delivered')}
																</div>
															}

															{item.status < 9 &&
																<div className="table-dropdown-item"
																	onClick={() => toggleModalInvoice(true, item)}>
																	<i className="uil-message"></i>
																	{t('issue_invoice')}
																</div>
															}

															{item.courier_id && item.status < 8 &&
																<div className="table-dropdown-item"
																	onClick={() => {
																		setDeleteModalParams({ id: item.id, index: index });
																		setModalDelete({
																			'cheque': false,
																			'courier': true,
																		})
																	}}>
																	<i className="uil-times"></i>
																	{t('remove_courier_from_cheque')}
																</div>
															}

															{item.client_longitude &&
																<div className="table-dropdown-item"
																	onClick={() => toggleModal(true, 'mapOrder', item)}>
																	<i className="uil uil-map-marker"></i>
																	{t('map')}
																</div>
															}

															{!!item.client_id &&
																<div className="table-dropdown-item"
																	onClick={() => toggleModalClient(true, item)}>
																	<i className="uil-edit-alt"></i>
																	{t('edit_client')}
																</div>
															}

															{item.status < -1 &&
																<div className="table-dropdown-item text-danger"
																	onClick={() => {
																		setDeleteModalParams({ id: item.id, index: index });
																		setModalDelete({
																			'cheque': true,
																			'courier': false,
																		})
																	}}>
																	<i className="uil-times"></i>
																	{t('delete')}
																</div>
															}
														</Dropdown.Menu>
													</Dropdown>
												</div>
											</td>
										</tr>
									</Fragment>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL CLIENT */}
			<Modal show={modalClient} animation={false} centered backdrop="static"
				dialogClassName="update-modal-width" onHide={() => toggleModalClient()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('edit')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => updateClient(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="first_name"
								value={selectedItem.first_name ?? ''}
								onChange={(e) => handleClientChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('additional_phone')}</label>
							<input type="number" className="form-control" name="phone2"
								value={selectedItem.phone2 ?? ''}
								onChange={(e) => handleClientChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('birthday')}</label>
							<input type="date" className="form-control" name="birthday"
								value={selectedItem.birthday ?? ''}
								onChange={(e) => handleClientChange(e)} />
						</div>
						<div className="d-flex justify-content-between mb-2">
							<div className="d-flex gap-2">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setSelectedItem({ ...selectedItem, 'gender': 1 })}
										style={{ 'backgroundColor': selectedItem.gender === 1 ? 'black' : '' }}>
									</div>
									<span onClick={() => setSelectedItem({ ...selectedItem, 'gender': 1 })}>
										{t('man')}
									</span>
								</div>

								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setSelectedItem({ ...selectedItem, 'gender': 2 })}
										style={{ 'backgroundColor': selectedItem.gender === 2 ? 'black' : '' }}>
									</div>
									<span onClick={() => setSelectedItem({ ...selectedItem, 'gender': 2 })}>
										{t('woman')}
									</span>
								</div>
							</div>
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ''}
								onChange={(e) => handleClientChange(e)} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalMap()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CLIENT */}

			{/* MODAL OPERATOR CHEQUES */}
			<Modal show={modalCheques} animation={false} centered size="xl"
				onHide={() => toggleModalCheques(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('operators')} [{cheques?.data?.length}]</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-2">
						<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
							<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
								{t('filter')}
							</Dropdown.Toggle>

							<Dropdown.Menu className="dropdown-filter">
								<div className="row">
									<div className="form-group col-md-6">
										<label>{t('period')}</label>
										<div className="calendar-input">
											<DatePicker
												className="form-control"
												dateFormat="dd.MM.yyyy"
												selected={filterData.start_date ? new Date(filterData.start_date) : ''}
												onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
									<div className="form-group col-md-6">
										<label className="invisible">.</label>
										<div className="calendar-input">
											<DatePicker
												className="form-control"
												dateFormat="dd.MM.yyyy"
												selected={filterData.end_date ? new Date(filterData.end_date) : ''}
												onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-md-12">
										<div className="d-flex justify-content-end gap-2">
											<button className="btn btn-secondary"
												onClick={() => setDropdownIsOpen(false)}>
												{t('cancel')}
											</button>
											<button className="btn btn-primary"
												onClick={() => toggleModalCheques(true)}>
												{t('apply')}
											</button>
										</div>
									</div>
								</div>
							</Dropdown.Menu>
						</Dropdown>
					</div>

					<div className="filter-block">
						<div className="filter">
							<strong>{t('filter')}</strong>
							<br />
							{(filterData.start_date || filterData.end_date) &&
								<span className="me-2">
									<b>{t('period')}: </b>
									{filterData.start_date &&
										<span>{formatDate(filterData.start_date)}</span>
									}
									{(filterData.start_date && filterData.end_date) &&
										<span>|</span>
									}
									{filterData.end_date &&
										<span>{formatDate(filterData.end_date)}</span>
									}
								</span>
							}
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '30%' }} className="td-ellipsis">{t('operators')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis text-end">{t('products')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis text-end"
										title={t('average_products_per_cheque')}>
										{t('average_products_per_cheque')}
									</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis text-end">{t('average_check')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis text-end">{t('takeaway')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis text-end">{t('delivery')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis text-end">{t('cheques')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{cheques?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis">{item.operator_name}</td>
										<td className="text-end">{formatMoney(item.total_products)}</td>
										<td className="text-end">{formatMoney(item.avg_products_per_cheque, 2)}</td>
										<td className="text-end">{formatMoney(item.avg_total_amount)}</td>
										<td className="text-end">{formatMoney(item.count_takeaway)}</td>
										<td className="text-end">{formatMoney(item.count_delivery)}</td>
										<td className="text-end">{formatMoney(item.count_cheques)}</td>
										<td className="text-end">{formatMoney(item.total_amount)}</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td className="text-end"><b>{formatMoney(cheques?.overall?.overall_products)}</b></td>
									<td></td>
									<td></td>
									<td className="text-end"><b>{formatMoney(cheques?.overall?.overall_takeaway)}</b></td>
									<td className="text-end"><b>{formatMoney(cheques?.overall?.overall_delivery)}</b></td>
									<td className="text-end"><b>{formatMoney(cheques?.overall?.overall_cheques)}</b></td>
									<td className="text-end"><b>{formatMoney(cheques?.overall?.overall_cheques_amount)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL OPERATOR CHEQUES */}

			{/* MODAL CLOSED CHEQUES */}
			{modalClosedCheques &&
				<Modal show={modalClosedCheques} animation={false}
					centered size="xl"
					onHide={() => toggleModalClosedCheques()}>
					<Modal.Header closeButton>
						<Modal.Title>{t('cheques')} [{cheques?.data?.length}]</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="d-flex flex-wrap gap-2 mb-3">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									{t('filter')}
								</Dropdown.Toggle>

								<Dropdown.Menu className="dropdown-filter">
									<div className="row">
										<div className="form-group col-md-6">
											<label>{t('period')}</label>
											<div className="calendar-input">
												<DatePicker
													className="form-control"
													dateFormat="dd.MM.yyyy"
													selected={filterData.start_date ? new Date(filterData.start_date) : ''}
													onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
										<div className="form-group col-md-6">
											<label className="invisible">.</label>
											<div className="calendar-input">
												<DatePicker
													className="form-control"
													dateFormat="dd.MM.yyyy"
													selected={filterData.end_date ? new Date(filterData.end_date) : ''}
													onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end gap-2">
												<button className="btn btn-secondary"
													onClick={() => setDropdownIsOpen(false)}>
													{t('cancel')}
												</button>
												<button className="btn btn-primary"
													onClick={() => toggleModalClosedCheques(true)}>
													{t('apply')}
												</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>

						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
							</div>
						</div>

						<div className="table-responsive table-fixed" style={{ 'height': '400px', 'overflow': 'auto' }}>
							<table className="table table-bordered table-hover mb-0">
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '15%' }} className="td-ellipsis">{t('pos')}</th>
										<th style={{ 'width': '20%' }}>{t('cashier')}</th>
										<th style={{ 'width': '20%' }}>{t('waiter')}</th>
										<th style={{ 'width': '15%' }}>{t('courier')}</th>
										<th style={{ 'minWidth': '50px' }} className="text-nowrap text-center">ID</th>
										<th style={{ 'minWidth': '50px' }} className="text-nowrap text-center">{t('cheque')} №</th>
										<th style={{ 'width': '15%' }} className="text-center">{t('delivery_type')}</th>
										<th style={{ 'minWidth': '115px' }} className="td-ellipsis text-center">{t('open_date')}</th>
										<th style={{ 'minWidth': '115px' }} className="td-ellipsis text-center">{t('close_date')}</th>
										<th style={{ 'width': '15%' }} className="text-end">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{cheques?.data?.map((item, index) => (
										<tr className={`cursor ${item.showSidebar ? 'table-tr-active' : ''}`} key={index}>
											<td className="text-center" title={item.id}>
												{item.row_number}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
												{item.pos_short_name}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
												{item.cashier_name}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
												{item.waiter_name}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
												{item.courier_name}
											</td>
											<td onClick={() => toggleRightbar(true, item, index)} className="text-center">
												{item.cheque_id}
											</td>
											<td onClick={() => toggleRightbar(true, item, index)} className="text-center">
												{item.cheque_number}
											</td>
											<td onClick={() => toggleRightbar(true, item, index)} className={`text-center ${returnClassStatus(item.order_type)}`}>
												{item.order_type_sub_name}
											</td>
											<td onClick={() => toggleRightbar(true, item, index)} className="text-center">
												{formatDate(item.cheque_opened_at, 'dd.MM.yy HH:mm')}
											</td>
											<td onClick={() => toggleRightbar(true, item, index)} className="text-center">
												{formatDate(item.cheque_closed_at, 'dd.MM.yy HH:mm')}
											</td>
											<td className={`text-end text-nowrap ${item.entity_debtor_id ? 'bg-danger text-white' : ''}`}
												onClick={() => toggleRightbar(true, item, index)}>
												{formatMoney(item.total_amount_service)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>

						{pagination.response &&
							<FilterPagination
								pagination={pagination}
								paginate={paginate}>
							</FilterPagination>
						}
					</Modal.Body>
				</Modal>
			}
			{/* MODAL CLOSED CHEQUES */}

			{/* MODAL PREORDER CHEQUES */}
			{modalPreorderCheques &&
				<Modal show={modalPreorderCheques} animation={false} centered
					dialogClassName="modal-fullscreen"
					onHide={() => toggleModalPreorderCheques()}>
					<Modal.Header closeButton>
						<Modal.Title>{t('pre_order')} [{cheques?.data?.length}]</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="mb-2">
							<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									{t('filter')}
								</Dropdown.Toggle>

								<Dropdown.Menu className="dropdown-filter">
									<div className="row">
										<div className="form-group col-md-6">
											<label>{t('period')}</label>
											<div className="calendar-input">
												<DatePicker
													className="form-control"
													dateFormat="dd.MM.yyyy"
													selected={filterData.start_date ? new Date(filterData.start_date) : ''}
													onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
										<div className="form-group col-md-6">
											<label className="invisible">.</label>
											<div className="calendar-input">
												<DatePicker
													className="form-control"
													dateFormat="dd.MM.yyyy"
													selected={filterData.end_date ? new Date(filterData.end_date) : ''}
													onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end gap-2">
												<button className="btn btn-secondary"
													onClick={() => setDropdownIsOpen(false)}>
													{t('cancel')}
												</button>
												<button className="btn btn-primary"
													onClick={() => toggleModalPreorderCheques(true)}>
													{t('apply')}
												</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>

						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
							</div>
						</div>

						<div className="table-responsive">
							<table className="table table-bordered table-hover mb-0">
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'minWidth': '115px' }} className="text-center">{t('date')}</th>
										<th style={{ 'width': '10%' }}>{t('branch')}</th>
										<th style={{ 'width': '10%' }}>{t('created_by')}</th>
										<th style={{ 'width': '10%' }}>{t('payment')}</th>
										<th style={{ 'width': '10%' }} className="text-center">{t('type')}</th>
										<th style={{ 'width': '10%' }} className="text-start">{t('client')}</th>
										<th style={{ 'width': '10%' }} className="text-center">{t('phone')}</th>
										<th style={{ 'width': '30%' }} className="text-center">{t('address')}</th>
										<th style={{ 'minWidth': '115px' }} className="text-center">{t('created')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
										<th style={{ 'minWidth': '33px' }}></th>
									</tr>
								</thead>
								<tbody>
									{cheques?.data.map((item, index) => (
										<tr className={`cursor ${item.showSidebar ? 'table-tr-active' : ''}`} key={index}>
											<td className="text-center" title={item.id}>
												{index + 1}
											</td>
											<td onClick={() => toggleRightbar(true, item, index)} className="text-center">
												{formatDate(item.cheque_scheduled_at, 'dd.MM.yy HH:mm')}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
												{item.pos_name}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
												{item.operator_name}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
												{item.payment_name}
											</td>
											<td className="text-center"
												onClick={() => toggleRightbar(true, item, index)}>
												{item.order_type === 2 &&
													<span>{t('takeaway')}</span>
												}
												{item.order_type === 3 &&
													<span>{t('delivery')}</span>
												}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
												{item.client_name}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
												{item.client_phone}
											</td>
											<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}
												title={item.client_address}>
												{item.client_address}
											</td>
											<td onClick={() => toggleRightbar(true, item, index)} className="text-center">
												{formatDate(item.cheque_opened_at, 'dd.MM.yy HH:mm')}
											</td>
											<td className={`text-end text-nowrap ${item.entity_debtor_id ? 'bg-danger text-white' : ''}`}
												onClick={() => toggleRightbar(true, item, index)}>
												{formatMoney(item.total_amount_service)}
											</td>
											<td>
												<div className="table-dropdown">
													<Dropdown id={`dropdown-${index}`}>
														<Dropdown.Toggle variant="outline-primary">
															<i className="uil uil-ellipsis-v"></i>
														</Dropdown.Toggle>

														<Dropdown.Menu>
															{item.status < 7 &&
																<div className="table-dropdown-item d-non"
																	onClick={() => goTo('update', item)}>
																	<i className="uil-edit"></i>
																	{t('edit')}
																</div>
															}

															{item.status < 7 &&
																<div className="table-dropdown-item"
																	onClick={() => toggleModalAddress(true, item)}>
																	<i className="uil-map"></i>
																	{t('change_address')}
																</div>
															}

															{Number(item.paid) === 0 &&
																<div className="table-dropdown-item"
																	onClick={() => toggleModalPayments(true, item)}>
																	<i className="uil-sync"></i>
																	{t('change_payment')}
																</div>
															}

															{item.status < 9 &&
																<div className="table-dropdown-item"
																	onClick={() => toggleModalInvoice(true, item)}>
																	<i className="uil-message"></i>
																	{t('issue_invoice')}
																</div>
															}

															{item.status < -1 &&
																<div className="table-dropdown-item text-danger"
																	onClick={() => {
																		setDeleteModalParams({ id: item.id, index: index });
																		setModalDelete({
																			'cheque': true,
																			'courier': false,
																		})
																	}}>
																	<i className="uil-times"></i>
																	{t('delete')}
																</div>
															}
														</Dropdown.Menu>
													</Dropdown>
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</Modal.Body>
				</Modal>
			}
			{/* MODAL PREORDER CHEQUES */}

			{/* MODAL BRANCHES */}
			<Modal show={modal.branches} animation={false} centered size="md"
				onHide={() => toggleModal(false, 'branches')}>
				<Modal.Header closeButton>
					<Modal.Title>{t('branches')} [{poses?.length}]</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '50%' }} className="td-ellipsis">{t('branch')}</th>
									<th style={{ 'width': '25%' }} className="td-ellipsis text-center">{t('status')}</th>
									<th style={{ 'width': '25%' }} className="td-ellipsis text-end">{t('orders')}</th>
								</tr>
							</thead>
							<tbody>
								{poses?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis">{item.name}</td>
										<td style={returnOnlineStatus(item)}></td>
										<td className="td-ellipsis text-end">{formatMoney(item.count)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL BRANCHES */}

			{/* MODAL DASHBOARD */}
			<Modal show={modal.dashboard} animation={false} centered size="xl"
				onHide={() => toggleModal(false, 'dashboard')}>
				<Modal.Body>
					<div className="mb-2">
						<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
							<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
								{t('filter')}
							</Dropdown.Toggle>

							<Dropdown.Menu className="dropdown-filter">
								<div className="row">
									<div className="form-group col-md-6">
										<label>{t('period')}</label>
										<div className="calendar-input">
											<DatePicker
												className="form-control"
												dateFormat="dd.MM.yyyy"
												selected={filterData.start_date ? new Date(filterData.start_date) : ''}
												onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
									<div className="form-group col-md-6">
										<label className="invisible">.</label>
										<div className="calendar-input">
											<DatePicker
												className="form-control"
												dateFormat="dd.MM.yyyy"
												selected={filterData.end_date ? new Date(filterData.end_date) : ''}
												onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-md-12">
										<div className="d-flex justify-content-end gap-2">
											<button className="btn btn-secondary"
												onClick={() => setDropdownIsOpen(false)}>
												{t('cancel')}
											</button>
											<button className="btn btn-primary"
												onClick={() => toggleModalCheques(true)}>
												{t('apply')}
											</button>
										</div>
									</div>
								</div>
							</Dropdown.Menu>
						</Dropdown>
					</div>

					<div className="filter-block">
						<div className="filter">
							<strong>{t('filter')}</strong>
							<br />
							{(filterData.start_date || filterData.end_date) &&
								<span className="me-2">
									<b>{t('period')}: </b>
									{filterData.start_date &&
										<span>{formatDate(filterData.start_date)}</span>
									}
									{(filterData.start_date && filterData.end_date) &&
										<span>|</span>
									}
									{filterData.end_date &&
										<span>{formatDate(filterData.end_date)}</span>
									}
								</span>
							}
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL DASHBOARD */}

			{/* MODAL INVOICE */}
			{modalInvoice &&
				<Modal show={modalInvoice} animation={false} centered
					dialogClassName="update-modal-width" backdrop="static"
					onHide={() => toggleModalInvoice()}>
					<Modal.Header closeButton>
						<Modal.Title>{t('issue_invoice')}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form onSubmit={(e) => sendInvoice(e)} autoComplete="off">
							<div className="form-group w-100">
								<label>{t('phone')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="client_phone"
									value={selectedItem.client_phone ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'client_phone': e.target.value })} />
							</div>

							<div className="form-group">
								<label>{t('payment_type')}</label>
								<Select
									options={paymentTypes}
									value={paymentTypes.find(option => option.id === selectedItem.payment_type_id) || ''}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'payment_type_id': option.id })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="d-flex gap-2">
								<div className="form-group w-100">
									<label>{t('cheque')} ID</label>
									<input disabled type="text" className="form-control" name="cheque_id"
										value={selectedItem.cheque_id ?? ''}
										onChange={(e) => { }} />
								</div>
								<div className="form-group w-100">
									<label>{t('amount')}</label>
									<input disabled type="text" className="form-control" name="amount"
										value={formatMoney(selectedItem.amount)}
										onChange={(e) => { }} />
								</div>
							</div>

							<div className="d-flex w-100 mt-3 gap-2">
								<button type="button" className="btn btn-outline-warning w-100"
									onClick={() => toggleModalInvoice()}>
									{t('cancel')}
								</button>
								<button type="submit" className="btn btn-primary w-100"
									disabled={!(selectedItem.client_phone)}>
									{t('save')}
								</button>
							</div>
						</form>
					</Modal.Body>
				</Modal>
			}
			{/* MODAL INVOICE */}

			{/* MODAL PAYMENT TYPES */}
			{modalPaymentTypes &&
				<Modal show={modalPaymentTypes} animation={false}
					centered size="sm"
					onHide={() => toggleModalPayments()}>
					<Modal.Body>
						<div className="addition-wrapper no-scroll">
							{reduxDelivery.paymentTypes?.map((item, index) => (
								<Fragment key={index}>
									{(item.payment_type_category_id === 1 || item.payment_type_category_id === 2 || item.payment_type_category_id === 5) &&
										<div className="addition-wrapper-item"
											style={{ 'backgroundColor': '#CE34AC' }}
											onClick={() => changePaymentType(item)}>
											{item.name}
										</div>
									}
								</Fragment>
							))}
						</div>
					</Modal.Body>
				</Modal>
			}
			{/* MODAL PAYMENT TYPES */}

			{/* MODAL ADDRESS */}
			{modalAddress &&
				<Modal show={modalAddress} animation={false} centered
					dialogClassName="update-modal-width" backdrop="static"
					onHide={() => toggleModalAddress()}>
					<Modal.Header closeButton>
						<Modal.Title>{t('change_address')}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form onSubmit={(e) => changeAddress(e)} autoComplete="off">
							<div className="d-flex gap-2" style={{ 'height': '315px', 'overflow': 'auto' }}>
								<div className="w-50">
									{selectedItem?.addresses?.length > 0 &&
										<>
											{selectedItem?.addresses?.map((item, index) => (
												<div key={index}
													className={`client-address${selectedItem?.address_id === item.id ? ' active' : ''}`}
													onClick={() => {
														if (selectedItem.address_id === item.id) {
															clearSelectedAddress()
															return;
														}
														if (!item.id) {
															setSelectedItem({ ...selectedItem, 'address_id': item.id, 'address': '' })
														} else {
															if (selectedItem.order_type === 3) handleSelectAddress(item)
														}
													}}>
													<div className="max-lines-3">
														{item.short_address}
													</div>
												</div>
											))}
										</>
									}
								</div>

								<div className="w-50">
									<>
										<div className="form-group">
											<label>{t('coordinates')}</label>
											<div className="position-relative">
												<input type="text" className="form-control" name="coordinates"
													disabled={!(client.id && selectedItem.order_type === 3)}
													autoComplete="off"
													value={data.coordinates ?? ''}
													onChange={(e) => {
														parseCoordinates(e.target.value)
													}}
												/>
												<button type="button" className="input-button-right delivery"
													disabled={!(selectedItem.order_type === 3)}
													onClick={() => toggleModalMap(true)}>
													<i className="uil uil-map-marker input-icon"></i>
												</button>
											</div>
										</div>

										<div className="d-flex gap-2">
											<div className="form-group w-50">
												<label>{t('apartment')}</label>
												<input type="text" className="form-control" name="apartment"
													disabled={!(selectedItem.address_id)}
													autoComplete="off"
													value={selectedItem.apartment ?? ''}
													onChange={(e) => setSelectedItem({ ...selectedItem, 'apartment': e.target.value })}
												/>
											</div>
											<div className="form-group w-50">
												<label>{t('floor')}</label>
												<input type="text" className="form-control" name="floor"
													disabled={!(selectedItem.address_id)}
													autoComplete="off"
													value={selectedItem.floor ?? ''}
													onChange={(e) => setSelectedItem({ ...selectedItem, 'floor': e.target.value })}
												/>
											</div>
										</div>

										<div className="d-flex gap-2">
											<div className="form-group w-50">
												<label>{t('entrance')}</label>
												<input type="text" className="form-control" name="entrance"
													disabled={!(selectedItem.address_id)}
													autoComplete="off"
													value={selectedItem.entrance ?? ''}
													onChange={(e) => setSelectedItem({ ...selectedItem, 'entrance': e.target.value })}
												/>
											</div>
											<div className="form-group w-50">
												<label>{t('intercom')}</label>
												<input type="text" className="form-control" name="intercom"
													disabled={!(selectedItem.address_id)}
													autoComplete="off"
													value={selectedItem.intercom ?? ''}
													onChange={(e) => setSelectedItem({ ...selectedItem, 'intercom': e.target.value })}
												/>
											</div>
										</div>
										<div className="form-group">
											<label>{t('navigate')}</label>
											<textarea type="text" className="form-control" name="navigate"
												style={{ 'minHeight': '68px' }}
												autoComplete="off"
												value={selectedItem.navigate ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'navigate': e.target.value })}
											/>
										</div>
									</>
								</div>
							</div>

							<div className="d-flex w-100 mt-3 gap-2">
								<button type="button" className="btn btn-outline-warning w-100"
									onClick={() => toggleModalAddress()}>
									{t('cancel')}
								</button>
								<button type="submit" className="btn btn-primary w-100">
									{t('save')}
								</button>
							</div>
						</form>
					</Modal.Body>
				</Modal>
			}
			{/* MODAL ADDRESS */}

			{modal.map &&
				<Map
					poses={poses}
					data={data}
					modal={modal}
					toggleModal={toggleModal}>
				</Map>
			}

			{modal.mapOrder &&
				<MapOrder
					modal={modal}
					toggleModal={toggleModal}>
				</MapOrder>
			}

			{/* MODAL MAP */}
			{modalMap &&
				<NewAddress
					modalMap={modalMap}
					newAddress={newAddress}
					setNewAddress={setNewAddress}
					toggleModalMap={toggleModalMap}
					createClientAddress={createClientAddress}>
				</NewAddress>
			}
			{/* MODAL MAP */}

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				selectedItem={selectedItem}>
			</Rightbar>

			{modalDelete.cheque &&
				<DeleteModalCheque
					modalDelete={modalDelete}
					setModalDelete={setModalDelete}
					deleteItem={deleteCheque}>
				</DeleteModalCheque>
			}

			{modalDelete.courier &&
				<DeleteModalCourier
					modalDelete={modalDelete}
					setModalDelete={setModalDelete}
					deleteItem={deleteCourier}>
				</DeleteModalCourier>
			}
		</>
	)
}

export default Orders